import DepartmentSelector from "../../../components/selectors/DepartmentSelector";

export type ExamTargetDepartment = { id: string; name: string; color?: string | null };

// Denemeyi görecek bölümler (26 Eki): boş = kurumdaki herkes; üst bölüm seçilirse altındaki şubeler de görür.
export default function ExamAudiencePicker({
  value,
  onChange,
  disabled = false,
}: {
  value: ExamTargetDepartment[];
  onChange: (next: ExamTargetDepartment[]) => void;
  disabled?: boolean;
}) {
  return (
    <div>
      <DepartmentSelector
        value=""
        onChange={(departmentId, department) => {
          if (!departmentId || !department || value.some((d) => d.id === departmentId)) return;
          onChange([...value, { id: departmentId, name: department.name, color: department.color || null }]);
        }}
        placeholder="Bölüm ekle"
        excludeIds={value.map((d) => d.id)}
        allowClear={false}
        showColors
        disabled={disabled}
        className="w-full"
      />
      {value.length > 0 ? (
        <div className="mt-2 flex flex-wrap gap-1">
          {value.map((d) => (
            <span key={d.id} className="inline-flex items-center gap-1 rounded bg-blue-100 px-2 py-1 text-xs text-blue-800">
              {d.color && <span className="h-3 w-3 rounded-full" style={{ backgroundColor: d.color }} />}
              {d.name}
              <button
                type="button"
                disabled={disabled}
                onClick={() => onChange(value.filter((x) => x.id !== d.id))}
                className="ml-1 text-blue-600 hover:text-blue-800"
                aria-label={`${d.name} çıkar`}>
                ×
              </button>
            </span>
          ))}
        </div>
      ) : null}
      <p className="mt-1 text-xs text-gray-500">
        {value.length
          ? "Yalnız seçili bölümlerdeki öğrenciler bu denemeyi görür ve çözer. Üst bölüm (ör. 11. Sınıflar) altındaki şubeleri de kapsar."
          : "Boş bırakırsan kurumdaki bütün öğrenciler görür. Yalnız bir sınıf görsün istiyorsan bölümünü seç (ör. 11. Sınıflar)."}
      </p>
    </div>
  );
}
